import { render, staticRenderFns } from "./UpdateSocialEssayPage.vue?vue&type=template&id=6fea59ca&scoped=true"
import script from "./UpdateSocialEssayPage.vue?vue&type=script&lang=js"
export * from "./UpdateSocialEssayPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fea59ca",
  null
  
)

export default component.exports